<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="psiModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader"> {{ this.domain }} </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="loading" class="modal-body">
            <div class="loader"></div>
          </div>
          <div v-else class="modal-body">
           <section>
             <div class="row">
               <div class="col-md-12">
<button type="button" @click="createNewPSI()"  class="btn btn-sm btn-primary" style="float:right; margin-bottom: 20px;">
              Create New PSI
            </button>
               </div>

             </div>

           </section>

            <section v-if="psiRecords.length>0">
              <section v-for="(row, p_index) of psiRecords" :key="p_index">
                <div class="row">
                  <div class="col-md-12">
                    <h5 class="text-primary"><b>Created Date:</b> {{format_date(row.created_at)}}</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <h5 class="text-primary"><b>Mobile</b></h5>
                        <b>URL:</b> {{domain}} <br>
                        <b>Performance:</b> <b> {{(row.mobile.performance * 100).toFixed(2)}}%</b> <br><br>
                        <b>Field Data</b> <br><br>
                        <b>First Contentful Paint (FCP):</b> {{row.mobile.first_contentful_paint_3g}} <br>
                        <b>First Input Delay (FID):</b> {{row.mobile.max_potential_fid}} <br>
                        <b>Largest Contentful Paint (LCP):</b> {{row.mobile.largest_contentful_paint}} <br>
                        <b>Cumulative Layout Shift (CLS):</b> {{row.mobile.cumulative_layout_shift}} <br>


                  </div>
                  <div class="col-md-6">
                    <h5 class="text-primary"><b>Desktop</b></h5>
                        <b>URL:</b> {{domain}} <br>
                        <b>Performance:</b> <b> {{(row.desktop.performance*100).toFixed(2)}}%</b> <br><br>
                        <b>Field Data</b> <br><br>
                        <b>First Contentful Paint (FCP):</b> {{row.desktop.first_contentful_paint_3g}} <br>
                        <b>First Input Delay (FID):</b> {{row.desktop.max_potential_fid}} <br>
                        <b>Largest Contentful Paint (LCP):</b> {{row.desktop.largest_contentful_paint}} <br>
                        <b>Cumulative Layout Shift (CLS):</b> {{row.desktop.cumulative_layout_shift}} <br>

                  </div>
                </div>
                  <hr>

              </section>
            </section>
            <section v-else>
              <div class="col-md-12">
              <h3 class="text-danger text-center">No Records Found!</h3>

              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {db} from "@/firebase/init"
import moment from 'moment'
import swal from "sweetalert2";
import _ from "lodash";

export default {
  name: "psiModal",

  data () {
    return {
      psiRecords: [],
      domain: '',
      loading: false,
      editIndex: -1
    }
  },
  computed:{

  },
  methods: {
    async load (domain) {
      console.log(domain)
      this.domain=domain
      $('#psiModal').modal('show');
      this.loading=true;
     await this.fetchPsiRecords()

      this.loading=false;
    },
      async createNewPSI(){
         try {
               this.loading=true
       const data=await  this.$http.post('/utilities/psi', {
          grant_type: 'token',
          domain: this.domain
        })
        await this.fetchPsiRecords();

        this.loading=false;
              swal({
                title: "Success",
                text: 'Psi created successfully!',
                type: "success",
              });
            } catch (e) {

              this.loading=false;
              console.log(e.toString());
              console.log('Error in creating psi');
              swal({
                title: "Error",
                text: e.response.data.message,
                type: "error",
              });
            }


    },
    format_date(value){
      value=new Date(value);
         if (value) {
           console.log('%cpsiModal.vue line:140 "object"', 'color: #007acc;', moment(value).format("hh:mm:ss a"));
           return `${moment(String(value)).format('YYYY-MM-DD')}, ${moment(value).format("hh:mm:ss a")}`
          }
      },
     async fetchPsiRecords(){

       let data=await db.collection('psi').doc(this.domain).get();
       console.log('%cpsiModal.vue line:146 data.data', 'color: #007acc;', data.data());
      if(data.data()){
        this.psiRecords=data.data().results
        this.psiRecords=_.orderBy(this.psiRecords, 'created_at', 'desc')

      }
      else {
        this.psiRecords=[]
      }
      return this.psiRecords

    }

  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
</style>
